export const isInsideSalesforceIframe = (): boolean => {
  try {
    return window.self !== window.top &&
      (
        /\.force\.com/i.test(document.referrer)
      ||
         /\.salesforce\.com/i.test(document.referrer)
      );
  }
  catch (e) {
    return false;
  }
};
